export function createDataFunction(data) {
    return function (override) {
        const clone = structuredClone(data ?? {});
        return Object.assign(clone, override ?? {});
    };
}
